module.exports = __webpack_public_path__ + "static/media/promulgation-animation-main-img.bdce051c.jpg";